"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.preApprovedPropertyRepairSchema_Audit = exports.preApprovedPropertyRepairSchema = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var common_1 = require("../../../common");
var Joi = require('joi').extend(require('@joi/date'));
exports.preApprovedPropertyRepairSchema = Joi.object({
    amount: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .required()
        .options({ convert: false })
        .precision(2),
    borrowerChargeCode: Joi.string()
        .min(3)
        .max(3)
        .required()
        .valid(claim_domain_1.BorrowerChargesCode.PropertyRepairs),
    cmhcLoanAccountNumber: Joi.number()
        .integer()
        .required()
        .min(1000000)
        .max(99999999)
        .options({ convert: false }),
});
exports.preApprovedPropertyRepairSchema_Audit = exports.preApprovedPropertyRepairSchema.concat(common_1.auditFieldsSchema);
